<app-navbar></app-navbar>

<div class="breadcrumb">
    <a href="/">YouPrice</a>  &rarr; 
    <strong>FAQ YouPrice</strong>
</div>



<div class="faq-container">
  
  <div class="faq-header">
    <h1><span>FAQ</span> YouPrice</h1>
    <div class="search-bar">
      <input type="text" placeholder="Rechercher un sujet, une question, un mot-clé..." [(ngModel)]="searchQuery">
    <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
  <path d="M16.6 18L10.3 11.7C9.8 12.1 9.225 12.4167 8.575 12.65C7.925 12.8833 7.23333 13 6.5 13C4.68333 13 3.14583 12.3708 1.8875 11.1125C0.629167 9.85417 0 8.31667 0 6.5C0 4.68333 0.629167 3.14583 1.8875 1.8875C3.14583 0.629167 4.68333 0 6.5 0C8.31667 0 9.85417 0.629167 11.1125 1.8875C12.3708 3.14583 13 4.68333 13 6.5C13 7.23333 12.8833 7.925 12.65 8.575C12.4167 9.225 12.1 9.8 11.7 10.3L18 16.6L16.6 18ZM6.5 11C7.75 11 8.8125 10.5625 9.6875 9.6875C10.5625 8.8125 11 7.75 11 6.5C11 5.25 10.5625 4.1875 9.6875 3.3125C8.8125 2.4375 7.75 2 6.5 2C5.25 2 4.1875 2.4375 3.3125 3.3125C2.4375 4.1875 2 5.25 2 6.5C2 7.75 2.4375 8.8125 3.3125 9.6875C4.1875 10.5625 5.25 11 6.5 11Z" fill="#94A3B8"/>
</svg>
    </div>
  </div>

  <div class="faq-home" *ngIf="!selectedCategoryId && !isSearching">
    <div class="section-title">
      <span class="blue-dash"></span>
      <h2>Parcourir par thématique</h2>
    </div>
    
    <div class="categories-grid">
      <div class="category-card" *ngFor="let cat of categories" (click)="selectCategory(cat.id)">
        <div class="icon-wrapper">
          <span class="material-icons">
            <img src="assets/img/{{ cat.icon }}.svg"  class="avatar" />
            </span> 
        </div>
        <h3>{{ cat.name }}</h3>
        <p>{{ cat.description }}</p>
      </div>
    </div>
  </div>

  <div class="faq-details" *ngIf="selectedCategoryId && !isSearching">
    
    <aside class="desktop-sidebar">
  <p class="sidebar-title">CATÉGORIES D'AIDE</p>
  <ul class="sidebar-list">
    <li *ngFor="let cat of categories" 
        [class.active]="cat.id === selectedCategoryId" 
        (click)="selectCategory(cat.id)">
      
      <span class="sidebar-icon" 
            [style.-webkit-mask-image]="'url(assets/img/' + cat.iconSmall + '.svg)'"
            [style.mask-image]="'url(assets/img/' + cat.iconSmall + '.svg)'">
      </span>
      
      {{ cat.name }}
    </li>
  </ul>
</aside>

    <div class="mobile-pills">
      <button *ngFor="let cat of categories" 
              class="pill-btn" 
              [class.active]="cat.id === selectedCategoryId"
              (click)="selectCategory(cat.id)">
        {{ cat.name }}
      </button>
    </div>

    <div class="questions-list">
      <div class="question-item" *ngFor="let q of filteredQuestions" [class.expanded]="expandedQuestionId === q.id">
        <button class="question-header" (click)="toggleQuestion(q.id)">
          <span class="q-title" [class.active-text]="expandedQuestionId === q.id">{{ q.title }}</span>
          <svg class="arrow-icon" [class.rotated]="expandedQuestionId === q.id" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 15l7-7 7 7"/></svg>
        </button>
        <div class="question-body" *ngIf="expandedQuestionId === q.id">
          <p [innerHTML]="q.answer"></p>
        </div>
      </div>
    </div>

  </div>

  <div class="faq-search-results" *ngIf="isSearching">
    <div class="section-title">
      <span class="blue-dash"></span>
      <h2>Résultats pour "{{ searchQuery }}"</h2>
    </div>

    <p *ngIf="searchResults.length === 0" class="no-results">
      Aucune réponse trouvée pour votre recherche. Essayez d'autres mots-clés.
    </p>

    <div class="questions-list" *ngIf="searchResults.length > 0">
      <div class="question-item" *ngFor="let q of searchResults" [class.expanded]="expandedQuestionId === q.id">
        <button class="question-header" (click)="toggleQuestion(q.id)">
          <span class="q-title" [class.active-text]="expandedQuestionId === q.id">{{ q.title }}</span>
          <svg class="arrow-icon" [class.rotated]="expandedQuestionId === q.id" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 15l7-7 7 7"/></svg>
        </button>
        <div class="question-body" *ngIf="expandedQuestionId === q.id">
          <p [innerHTML]="q.answer"></p>
        </div>
      </div>
    </div>
  </div>

  <div class="contact-banner">
    <div class="contact-text">
      <h2>Vous avez encore des <br> questions ?</h2>
      <p>Si vous n'avez pas trouvé de réponse dans notre centre d'aide, notre équipe de conseillers est à votre disposition.</p>
    </div>
    <button class="contact-btn" (click)="goToContact()">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
  <path d="M2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H2ZM10 9L2 4V14H18V4L10 9ZM10 7L18 2H2L10 7ZM2 4V2V4V14V4Z" fill="#1E293B"/>
</svg>Nous contacter
    </button>
  </div>

</div>







<app-always-there></app-always-there>
<app-small-faq></app-small-faq>
<app-interest-you></app-interest-you>
<app-footer></app-footer>